<template>
  <div class="expand-collapse-container" :style="style">
    <div class="content-container">
      <p class="content" ref="content">{{ content }}</p>
    </div>
    <div class="button-container" v-if="showButton">
      <div class="btn" @click="handleStatusChange">{{ butttonLabel }}</div>
    </div>
  </div>
</template>

<script>

const EXPAND_STATUS = 'expand'
const COLLAPSE_STATUS = 'collapse'

export default {
  components: {
  },
  props: {
    content: {
      require: true
    },
    minDisplayLines: {
      type: Number,
      default: 7
    },
    lineHeight: {
      type: Number,
      default: 16
    }
  },
  data () {
    return {
      status: COLLAPSE_STATUS,
      contenLines: 0
    }
  },
  computed: {
    butttonLabel () {
      if (this.status === EXPAND_STATUS) {
        return this.$t('hm.btn.collapse')
      } else {
        return this.$t('hm.btn.expand')
      }
    },
    showButton () {
      if (!this.content || this.contenLines < this.minDisplayLines) {
        return false
      }
      return true
    },
    style () {
      return {
        '--line-height': this.lineHeight + 'px'
      }
    }
  },
  created () {
    this.initContent()
  },
  beforeDestroy () {

  },
  methods: {
    initContent () {
      this.$nextTick(() => {
        this.contenLines = this.$refs.content.scrollHeight / this.lineHeight
      })
      if (this.status === COLLAPSE_STATUS) {
        this.collapseContent()
      }
    },
    handleStatusChange () {
      if (this.status === EXPAND_STATUS) {
        this.collapseContent()
        this.status = COLLAPSE_STATUS
      } else {
        this.expandContent()
        this.status = EXPAND_STATUS
      }
    },
    collapseContent () {
      this.$nextTick(() => {
        if (this.contenLines > this.minDisplayLines) {
          this.$refs.content.style.height = this.lineHeight * this.minDisplayLines + 'px'
        }
      })
    },
    expandContent () {
      this.$nextTick(() => {
        this.$refs.content.style.height = 'auto'
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.expand-collapse-container {
  .content-container {
    margin-bottom: 5px;

    .content {
      line-height: var(--line-height);
      font-size: 15px;
      margin: 0;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  .button-container {
    display: flex;
    font-size: 15px;
    cursor: pointer;
    justify-content: flex-end;
    color: #0096cc;
  }
}
</style>
